export default __webpack_public_path__ + "static/media/Eileen-Wong.8ece559c.jpg";